module.exports = __webpack_public_path__ + "static/media/CS2 -- 3.4.35723f93.png";